import { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import AddToCartButton from "../AddToCartButton";
import SizeChart from "../SizeChart";
import Sizes from "../Sizes";
import Thumbnail from "../Thumbnail";
import Title from "../Title";
import ConfigPane from "./ConfigPane";
import Meta from "../Meta";
import { defaultIntegrationConfig, integrationConfigs } from '../../../integration_configs/config2';
import { useIntegration } from "./useIntegration";

function Case2(props = {}) {

  useEffect(() => {
    window.fitafunnel = ['button-w-img', 'button-w/o-img'][Math.floor(Math.random() * 2)];
    return () => {
      window.fitafunnel = [];
    };
  }, []);

  useIntegration(defaultIntegrationConfig);

  return (<>
    <ConfigPane configs={integrationConfigs}/>
    <Container className='testCase'>
      <Row>
        <Thumbnail src = {props.thumbnail}/>
        <Col>
          <Meta {... props}/>
          <Title title={props.title}/>
          <p>{props.description}</p>
          <Sizes sizes={props.sizes}
            availability={4/5}
          />
          <SizeChart />
          <AddToCartButton />
        </Col>
      </Row>
    </Container>
  </>);
}

export { Case2 };
